module.exports = "https://kiosk-santa-rosa.mercywellness.com/_next/static/images/accessories-2abe539d71473a01419cad13093fba0f.jpg";